import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import CustomAxios from '../../../utility/customAxios';
import { queryClient } from '../queryClient';
import { queryKeys } from '../queryKeys';

export const destroyTask = async (uuid: string) => {
  const response = await CustomAxios.delete(`tasks/${uuid}`);
  return response.data;
};

interface UseDestroyTaskProps {
  uuid: string;
  onSuccessCallback: () => void;
}

export function useDestroyTask({ uuid, onSuccessCallback }: UseDestroyTaskProps) {
  return useMutation({
    mutationFn: () => destroyTask(uuid),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [queryKeys.allTasks, uuid] });

      onSuccessCallback();
    },
    onError: (err: AxiosError) => {
      if (err?.response?.status === 400) {
        alert('Failed to delete the task. Please try again and contact support if the problem persists.');
      }
    },
  });
}
